import React, { useState, useEffect, Fragment } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { getCommonDataBasedOnId, saveData } from "../store/customer/CustomerSocialAddUpdateFunction";
import { GET_CUSTOMER_DELEGATION } from "../../utils/constants";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
// import { ADD_UPDATE_CUSTOMER_DELEGATION } from "../../utils/constants";
import { ADD_CUSTOMER_DELEGATION } from "../../utils/constants";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import {
  useLazyFetchPersonInTableQuery,
  useFetchPersonInTableQuery,
  useUpdateCustomerDelegationMutation,
} from "../../utils/customer/customerTable";
import CreatePortalHOC from "../GlobalFeature/Fields/CreatePortalHOC";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import useKeyboardShortcuts from "../../hooks/KeysHandle/useKeyboardShortcuts";
//import { useFetchPermissionTableDataQuery } from "../../utils/users/permissions";
import { useFetchPermissionTableDataQuery } from "../../utils/company/companypermissions";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import { pushAlert } from "../../utils/alertSlice";
import SelectComponent from "../UniversalComponents/SelectComponent";
import { getCompanyId, getOrganizationId, getUserId } from "../../utils/utilityFunctions/localServices";
import { useParams } from "react-router-dom";

const AddUpdateCustomerDelegation = ({
  isOpen,
  closePopup = () => {},
  customerId,
  multiData,
  companyId,
  refetchCustomerData,
  show,
  setShow,
  alert,
  setAlert,
}) => {
  const token = useRequireAuth();
  useKeyboardShortcuts({
    Escape: closePopup,
  });

  const dispatch = useDispatch();
  const { id: customerIdfromParams } = useParams();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);

  const [errors, setErrors] = useState({});
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const { data: permissionsData } = useFetchPermissionTableDataQuery({ token: token?.token });

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setFormData((prevFormData) => ({ ...prevFormData, group_id: option?.group_name?.id }));

    setIsDropdownOpen(false);
  };

  const options = permissionsData?.data?.data;

  const [formData, setFormData] = useState({
    email: [],
    owner: 0,
    // role: "",
  });

  // const fetchTaskEditData = async (customerId) => {
  //   const url = `${GET_CUSTOMER_DELEGATION}${customerId}`;
  //   const getData = await getCommonDataBasedOnId(url, token?.token);

  //   if (getData?.data?.length > 0) {
  //     setFormData({ ...getData?.data[0], email: "" });
  //   }
  // };

  // useEffect(() => {
  //   fetchTaskEditData(customerId);
  // }, [customerId]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    console.log("name", e.target);

    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData?.email) {
      tempErrors.email = "Email is required";
    }
    // if (!formData?.owner && formData !== 0) {
    //   tempErrors.owner = "access is required";
    // }
    // if (!selectedOption) {
    //   tempErrors.selectedOption = "Role is required";
    // }

    setErrors(tempErrors);
    return Object.keys(!tempErrors).length === 0;
  };

  const [updateCustomerDelegation, { isLoading: delegationLoading }] = useUpdateCustomerDelegationMutation();

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return false;
    }

    const payload = {
      customer_id: customerIdfromParams,
      company_id: getCompanyId(),
      user_id: getUserId(),
      email: formData?.email,
      org_id: getOrganizationId(),
      multiData: [customerIdfromParams],
      owner: 0,
    };

    const response = await updateCustomerDelegation({
      token: token?.token,
      data: payload,
      isDelete: false,
    });
    // const customerData = {
    //   ...formData,
    //   customer_id: customerId,
    //   company_id: companyId,
    //   multiData: multiData?.length ? multiData : [customerId],
    //   // group_id: formData?.group_id,
    // };

    // const response = await saveData(ADD_CUSTOMER_DELEGATION, [customerData], token?.token);
    refetchCustomerData();
    if (response?.success || response?.data?.success || response?.data?.status) {
      dispatch(
        pushAlert({
          visible: true,
          message: response?.message,
          type: "success",
        })
      );

      closePopup();
    } else {
      dispatch(
        pushAlert({
          visible: true,
          message: response?.message,
          type: "danger",
        })
      );
    }
  };

  const handleInsert = (item) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      email: item,
    }));
  };

  //const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();
  const { data: personTableData } = useFetchPersonInTableQuery({
    token: token?.token,
    companyId: parsedCompanyData.company_id,
    data: "",
  });

  // const fetchPersonData = (data) => {
  //   fetchPersonInTable({ token: token?.token, data: data, companyId: parsedCompanyData.company_id });
  // };
  const tableDetail = {
    tableidclass: "usermodelmember",
  };

  const OutsideTaskClose = useClickOutside(() => {
    // closePopup(true);
  });

  return (
    isOpen && (
      <Fragment>
        <CreatePortalHOC dialog isOpen={isOpen}>
          <div className="fixed right-10 inset-y-0 z-[999] h-full w-full items-center justify-center flex bg-gray-900 bg-opacity-50 ">
            <div
              className="relative  mt-18 bg-white border border-E5ECF0 font-popns  rounded-md w-500px overflow-hidden no-scrollbar"
              ref={OutsideTaskClose}
            >
              <div className=" flex items-center justify-between  mr-2 pt-1.5  pb-1.5">
                <div className="px-2"></div>
                <br />
                <h3 className="text-16 font-500 text-2C495D">Customer Delegation </h3>

                <button
                  onClick={closePopup}
                  type="button"
                  className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg  text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                  data-modal-hide="assets-modal"
                >
                  {/* <svg
                    className="w-4 h-2.5"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg> */}
                  <CloseModalImg className="w-4 h-2.5" />
                  <span className="sr-only">Close modal</span>
                </button>
              </div>

              <form onSubmit={handleSave} className="w-full lg:max-h-[70vh]  overflow-x-hidden  no-scrollbar">
                <div className="basis-5/5 mb-3  px-4">
                  <div className="border-t border-[#BECBD3]"></div>
                  <label htmlFor="first_name" className="block text-lg pt-1">
                    <span className="text-13 font-400 text-434852">Email</span>
                    <span className=" text-red-500"> *</span>
                    {errors.email && <span className="text-red-700 text-12">{errors.email}</span>}
                  </label>

                  <SelectComponent
                    name="email"
                    options={personTableData?.data}
                    labelKey="name"
                    valueKey="email"
                    subLabelKey="email"
                    personList={true}
                    multiSelect={true}
                    onChange={handleFieldChange}
                  />

                  {/* <OwnerDropDown
                    tableidclass={tableDetail.tableidclass}
                    fetchPersonInTable={fetchPersonData}
                    DropData={personTableData}
                    handleInsert={handleInsert}
                    owner={formData?.email}
                    fieldname={"owner"}
                  /> */}
                  {show && <span className="text-red-700">{show}</span>}
                </div>
                {/* <div className="basis-5/5  px-4 ">
                  <label htmlFor="Designation" className="block mb-1 text-13 font-400 text-434852">
                    Access <span className=" text-red-500"> *</span>
                    {errors.owner && <span className="text-red-700 text-12">{errors.owner}</span>}
                  </label>
                  <select
                    id={`owner`}
                    name="owner"
                    onChange={handleFieldChange}
                    className={`form-select text-12 text-383838 text-md  bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full px-2.5 py-0.5`}
                  >
                    <option value="0" selected={parseInt(formData?.owner) === 0}>
                      Contributor
                    </option>
                    <option value="1" selected={parseInt(formData?.owner) === 1}>
                      Owner
                    </option>
                  </select>
                </div> */}
                {false && (
                  <div className="basis-5/5 mt-3 px-4">
                    <div className="flex">
                      <label className="block mb-1 text-13 font-400 text-434852">
                        Assign Role<span className=" text-red-500"> *</span>
                      </label>
                      {errors.selectedOption && <span className="text-red-700 text-12">{errors.selectedOption}</span>}
                    </div>
                    <div
                      className="flex justify-between items-center h-[30px] p-1 border border-DFE2E5 bg-white cursor-pointer rounded-[5px] px-2 text-383838 text-12 font-400 w-full hover:border-1D5D9B focus-within:border-1D5D9B"
                      onClick={toggleDropdown}
                    >
                      {selectedOption ? (
                        selectedOption.group_name.value
                      ) : (
                        <span className="text-gray-300 font-500">Select Role</span>
                      )}
                      <span className={`transition-transform ${isDropdownOpen ? "rotate-180" : ""}`}>
                        <DownArrow fill="#535252" />
                      </span>
                    </div>
                    {isDropdownOpen && (
                      <div className="fixed z-10 w-[466px] border border-gray-300 bg-white shadow-lg rounded-[5px]  text-383838 text-12 font-400">
                        {options.map((option, index) => (
                          <div
                            key={index}
                            className="cursor-pointer hover:bg-gray-300 p-1 px-2"
                            onClick={() => handleOptionSelect(option)}
                          >
                            {option.group_name.value}
                          </div>
                        ))}
                      </div>
                    )}
                    {selectedOption && (
                      <p className="font-bold" id={`role`} name="role">
                        {selectedOption.value}
                      </p>
                    )}
                  </div>
                )}
                <div className="flex justify-end py-4 text-14 w-full">
                  <div className="px-4">
                    <button
                      onClick={closePopup}
                      type="button"
                      className="w-[91px] text-535252 bg-F4F4F4 hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-500 h-[30px] text-center rounded"
                    >
                      CANCEL
                    </button>
                    <button
                      type="submit"
                      className="w-[91px] text-white bg-1D4469 hover:bg-20486F save-btn font-500 border border-gray-200 h-[30px]  ms-3 rounded"
                    >
                      SAVE
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </CreatePortalHOC>
      </Fragment>
    )
  );
};

export default AddUpdateCustomerDelegation;
